export default __webpack_public_path__ + "static/media/XIcon.3cc70559.svg";